import {fromJS, List, Map} from 'immutable';
import {
  LOAD_CARD_DATA_FULFILLED,
  LOAD_CARD_DATA_PENDING,
  LOAD_CARD_DATA_REJECTED,
  LOAD_FILTERS_FULFILLED,
  LOAD_FILTERS_PENDING,
  LOAD_FILTERS_REJECTED,
  RESET_DOWNLOAD_URL,
  SET_DOWNLOAD_URL_FULFILLED,
  SET_DOWNLOAD_URL_PENDING,
  SET_DOWNLOAD_URL_REJECTED,
  UPDATE_FILTERS,
} from '../../actions';

const initialState = new Map({
  cardData: new List(),
  downloadUrl: '',
  loading: false,
  cardsLoading: false,
  filters: new Map({
    grades: new List(),
  }),
});

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_DOWNLOAD_URL_PENDING:
    case LOAD_FILTERS_PENDING:
      return state.set('loading', true);

    case LOAD_CARD_DATA_PENDING:
      return state.set('cardsLoading', true);

    case SET_DOWNLOAD_URL_REJECTED:
    case LOAD_FILTERS_REJECTED:
      return state.set('loading', false);

    case LOAD_CARD_DATA_REJECTED:
      return state.set('cardsLoading', false);

    case LOAD_FILTERS_FULFILLED:
      return state.withMutations(map => {
        const filterMap = ({grades}) => ({grades});
        return map.set('loading', false)
          .set('filters', fromJS(filterMap(action.payload.data)));
      });

    case SET_DOWNLOAD_URL_FULFILLED:
      return state.withMutations(map => map.set('loading', false)
          .set('downloadUrl', action.payload.data));

    case LOAD_CARD_DATA_FULFILLED:
      return state.withMutations(map =>
        map.set('cardsLoading', false)
          .set('cardData', fromJS(action.payload.data))
      );

    case UPDATE_FILTERS:
      return state.withMutations(map => {
        const {parentName, id} = action.payload;
        const filterContainer = state.getIn(['filters', parentName]);
        const chosenIndex = filterContainer.findIndex(o => o.get('id') === id);
        map.setIn(['filters', parentName], filterContainer.update(chosenIndex, o => o.update('value', val => !val)));
      });

    case RESET_DOWNLOAD_URL:
      return state.set('downloadUrl', '');

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/features/characterDetail/reducers/pages/showLessonPlans.js